/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
/**
 * Performant way of getting image data for the tiles.
 */
export const SEQUENTIAL_TILE_SHADER = {
    uniforms: {
        texture: { value: null },
    },
    vertexShader: `
        varying vec2 vUv;
        uniform vec2 tileDimension;
        void main()
        {
            vUv = uv * tileDimension;
            gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
        }
    `,
    fragmentShader: `
        uniform sampler2D texture;
        uniform vec2 textureDimension;
        uniform vec2 tileDimension;
        varying vec2 vUv;
        void main()
        {
          float index = vUv.y * tileDimension.x + vUv.x;
          index = floor(index);

          float x = mod( index, textureDimension.x );
          x = floor(x);

          float y = (index - x) / textureDimension.x;
          y = floor(y);

          vec2 uv = vec2(x,y) / textureDimension;
          gl_FragColor = texture2D( texture, uv ).bgra;
        }
    `,
};
//# sourceMappingURL=SequentialTileShader.js.map